import { render, staticRenderFns } from "./ListUserPsychology.vue?vue&type=template&id=1ecfcfc1&"
import script from "./ListUserPsychology.vue?vue&type=script&lang=js&"
export * from "./ListUserPsychology.vue?vue&type=script&lang=js&"
import style0 from "./ListUserPsychology.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports